import React, {PureComponent, type ReactNode} from 'react'

type HrProps = {
    className: string
}

export class Hr extends PureComponent<HrProps> {

    public static defaultProps = {
        className: ""
    }

    render(): ReactNode {
        return (
            <hr className={`border-[0.5px] border-neutral-100 my-2 ${this.props.className}`}/>
        )
    }
}
